


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ButtonWithMessage extends Vue {
  @Prop({ required: true })
  path: string

  @Prop({ required: true })
  label: string

  @Prop({ required: true })
  message: string | undefined

  @Prop({ required: true })
  autoRedirect: boolean | undefined

  get buttonClass(): string[] {
    return [
      'c-btn',
      this.autoRedirect === true ? 'c-btn--secondary' : 'c-btn--positive',
      'c-btn--w-large',
      'c-btn--h-middle',
      'c-btn--center',
      'my-2',
      'px-4',
    ]
  }

  moveToNext() {
    location.href = this.path
  }
}
